import { takeUntil } from 'rxjs/operators';

import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

import { LifecycleHooks } from '@app/core/services/lifecycle-hooks.service';
import { CanSetSize } from './equal-size.models';
import { EqualSizeService } from './equal-size.service';

@Directive({ standalone: false, selector: '[adsptEqualSize]', providers: [LifecycleHooks] })
export class EqualSizeDirective implements CanSetSize, AfterViewInit, OnDestroy {
  @Input('adsptEqualSize')
  axis: 'width' | 'height' = 'width';

  constructor(
    readonly el: ElementRef<HTMLElement>,
    private es: EqualSizeService,
    private lh: LifecycleHooks,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.es
        .registerItem(this)
        .pipe(takeUntil(this.lh.destroy$))
        .subscribe((size) => (this.el.nativeElement.style[this.axis] = `${size}px`));
    });
  }

  ngOnDestroy(): void {
    this.es.unregisterItem(this);
  }
}
